// extracted by mini-css-extract-plugin
export default {"header":"SectionHeader_header__77Zgd","backButton":"SectionHeader_backButton__P3YtY"};